import FlexContainer from 'components/common/FlexContainer';
import { mobileMediaQuery } from 'utils/common';
import styled from '@emotion/styled';

export const Container = styled(FlexContainer)({
  gap: 48,
  margin: '24px 12% 80px',
  textAlign: 'center',
  [mobileMediaQuery]: {
    margin: '16px 20px 32px',
    gap: 32,
  },
});

export const TextContainer = styled(FlexContainer)({
  gap: 20,
});

export const BannerTextContainer = styled(FlexContainer)({
  flexDirection: 'row',
  justifyContent: 'center',
});
